export const schoolAchievement = [
  {
    id: 1,
    imageSrc: "/assets/img/home/achieve/1.svg",
    title: "500+",
    text: "Seminars & Webinars",
  },
  {
    id: 2,
    imageSrc: "/assets/img/home/achieve/2.svg",
    title: "200,000+",
    text: "Students Impacted",
  },
  {
    id: 3,
    imageSrc: "/assets/img/home/achieve/3.svg",
    title: "50000+",
    text: "Personalized Counselling",
  },
  {
    id: 4,
    imageSrc: "/assets/img/home/achieve/4.svg",
    title: "8000+",
    text: "Successful Clients",
  },
];


export const Details = [
  {
    id: 1,
    imageSrc: "/assets/img/home/achieve/1.svg",
    title: "824",
    text: "Medical College",
  },
  {
    id: 2,
    imageSrc: "/assets/img/home/achieve/2.svg",
    title: "1,29,805",
    text: "MBBS Seats",
  },
  {
    id: 3,
    imageSrc: "/assets/img/home/achieve/3.svg",
    title: "2,276,069",
    text: "Applicants",
  },
  {
    id: 4,
    imageSrc: "/assets/img/home/achieve/4.svg",
    title: "3000",
    text: "Foreign Universities",
  },
];

